import Model, { attr } from '@ember-data/model';

export default class WieConfigArrows extends Model {
  @attr('boolean') start;
  @attr('boolean') end;
}
